import { render, staticRenderFns } from "./EventPlace.vue?vue&type=template&id=63310f3f"
import script from "./EventPlace.vue?vue&type=script&lang=js"
export * from "./EventPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports